import { Skeleton } from 'primereact/skeleton';

type Props = {
    themeColors: any;
};

function ThemePreviewCard({ themeColors }: Readonly<Props>) {
    return (
        <div className="theme-preview-card p-2">
            <div className="d-flex align-items-center justify-content-between p-2" style={{ backgroundColor: 'white' }}>
                <Skeleton
                    size="2rem"
                    className="mr-2"
                    animation="none"
                    pt={{
                        root: {
                            style: {
                                backgroundColor: themeColors.primary,
                            },
                        },
                    }}
                ></Skeleton>
                <div className="d-flex align-items-center">
                    <Skeleton
                        width="10rem"
                        className="mb-2"
                        animation="none"
                        pt={{
                            root: {
                                style: {
                                    backgroundColor: themeColors.secondary,
                                },
                            },
                        }}
                    ></Skeleton>
                    <Skeleton shape="circle" size="2rem" className="ms-2" animation="none"></Skeleton>
                </div>
            </div>
            <Skeleton
                className="mb-2 mt-2"
                animation="none"
                pt={{
                    root: {
                        style: {
                            backgroundColor: themeColors.primary,
                        },
                    },
                }}
            ></Skeleton>
            <div className="d-flex pb-2" style={{ height: '215px' }}>
                <div className="h-100 p-2" style={{ width: '20%', backgroundColor: 'white' }}>
                    <Skeleton
                        width="100%"
                        height="0.5rem"
                        className="mb-2"
                        animation="none"
                        pt={{
                            root: {
                                style: {
                                    backgroundColor: themeColors.secondary,
                                },
                            },
                        }}
                    ></Skeleton>
                    <Skeleton
                        width="80%"
                        height="0.5rem"
                        className="mb-2"
                        animation="none"
                        pt={{
                            root: {
                                style: {
                                    backgroundColor: themeColors.secondary,
                                },
                            },
                        }}
                    ></Skeleton>
                    <Skeleton
                        width="80%"
                        height="0.5rem"
                        className="mb-2"
                        animation="none"
                        pt={{
                            root: {
                                style: {
                                    backgroundColor: themeColors.secondary,
                                },
                            },
                        }}
                    ></Skeleton>
                    <Skeleton
                        width="100%"
                        height="0.5rem"
                        className="mb-2"
                        animation="none"
                        pt={{
                            root: {
                                style: {
                                    backgroundColor: themeColors.secondary,
                                },
                            },
                        }}
                    ></Skeleton>
                </div>
                <div className="h-100 p-2 ms-2" style={{ width: '75%' }}>
                    <div className="d-flex h-40">
                        <div
                            className="p-2 d-flex flex-column justify-content-between"
                            style={{ width: '50%', height: '100px', backgroundColor: 'white' }}
                        >
                            <div style={{ backgroundColor: 'white' }}>
                                <Skeleton
                                    width="50%"
                                    className="mb-2"
                                    animation="none"
                                    pt={{
                                        root: {
                                            style: {
                                                backgroundColor: themeColors.secondary,
                                            },
                                        },
                                    }}
                                ></Skeleton>
                            </div>
                            <div className="justify-content-end d-flex" style={{ backgroundColor: 'white' }}>
                                <Skeleton
                                    width="30%"
                                    className="mb-2 me-2"
                                    animation="none"
                                    pt={{
                                        root: {
                                            style: {
                                                backgroundColor: themeColors.secondary,
                                            },
                                        },
                                    }}
                                ></Skeleton>
                                <Skeleton
                                    width="30%"
                                    className="mb-2"
                                    animation="none"
                                    pt={{
                                        root: {
                                            style: {
                                                backgroundColor: themeColors.primary,
                                            },
                                        },
                                    }}
                                ></Skeleton>
                            </div>
                        </div>
                        <div
                            className="p-2 ms-4 d-flex flex-column justify-content-between"
                            style={{ width: '50%', height: '100px', backgroundColor: 'white' }}
                        >
                            <div style={{ backgroundColor: 'white' }}>
                                <Skeleton
                                    width="50%"
                                    className="mb-2"
                                    animation="none"
                                    pt={{
                                        root: {
                                            style: {
                                                backgroundColor: themeColors.secondary,
                                            },
                                        },
                                    }}
                                ></Skeleton>
                            </div>
                            <div className="justify-content-end d-flex" style={{ backgroundColor: 'white' }}>
                                <Skeleton
                                    width="40%"
                                    className="mb-2"
                                    animation="none"
                                    pt={{
                                        root: {
                                            style: {
                                                backgroundColor: '#fb3f3f',
                                            },
                                        },
                                    }}
                                ></Skeleton>
                            </div>
                        </div>
                    </div>
                    <div className="d-flex h-40 p-2 mt-2" style={{ width: '100%', height: '93px', backgroundColor: 'white' }}>
                        <div className="d-flex flex-column justify-content-between w-100">
                            <div style={{ backgroundColor: 'white' }}>
                                <Skeleton
                                    width="5rem"
                                    className="mb-2"
                                    animation="none"
                                    pt={{
                                        root: {
                                            style: {
                                                backgroundColor: themeColors.secondary,
                                            },
                                        },
                                    }}
                                ></Skeleton>
                            </div>
                            <div className="justify-content-end d-flex" style={{ backgroundColor: 'white' }}>
                                <Skeleton
                                    width="5rem"
                                    className="mb-2"
                                    animation="none"
                                    pt={{
                                        root: {
                                            style: {
                                                backgroundColor: '#fb3f3f',
                                            },
                                        },
                                    }}
                                ></Skeleton>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ThemePreviewCard;
